import type { APPLICANT_ATTRIBUTION } from 'cpool-constants';

import { getBaseCreditDefaultValues } from './baseCredit';

export const getKontokorrentkreditDefaultValues = (attribution: APPLICANT_ATTRIBUTION) => ({
    ...getBaseCreditDefaultValues(attribution),
    beanspruchterBetrag: null,
    verfuegungsrahmen: null,
    zinssatz: null,
});
